/* eslint-disable fp/no-loops */
import { Decoration } from '@tiptap/pm/view';

import { TableQuery } from '../TableQuery';
import styles from './controllers-scss';

export const rowDraggingDecorations = (
  state: $TSFixMe,
  editor: $TSFixMe,
  draggingState: $TSFixMe
) => {
  const { selection } = state;
  const table = TableQuery.of(selection);
  const parentStart = table.getStartPos();
  const rowsHeight = table.getRowsHeight(editor.view);

  const dragPreview = document.createElement('div');
  dragPreview.classList.add(styles.tableDragPreview);
  dragPreview.style.width = draggingState.dragging ? '100%' : '0px';
  dragPreview.style.height = `${draggingState.dragPreviewHeight}px`;
  dragPreview.style.left = '0px';
  dragPreview.style.top = `${draggingState.top}px`;

  const rowDropCursor = document.createElement('div');
  rowDropCursor.classList.add(styles.rowDropCursor);
  rowDropCursor.style.width = draggingState.dragging ? '100%' : '0px';
  rowDropCursor.style.top =
    draggingState.dropIndex &&
    (
      rowsHeight.slice(0, draggingState.dropIndex).reduce((curr, height) => curr + height, 0) || 0
    ).toString() + 'px';

  return [
    Decoration.widget(parentStart, dragPreview),
    Decoration.widget(parentStart, rowDropCursor),
  ];
};
